import { Component, inject, OnInit } from '@angular/core';
import packageInfo from 'package.json';

import { TranslateDirective } from '@ngx-translate/core';
import { EnvironmentService } from '@mwe/services';
import { ENVIRONMENT_SERVICE_TOKEN } from '@mwe/constants';

@Component({
  selector: 'mwe-page-ribbon',
  template: `
    @if (ribbonEnv !== 'prod') {
      <div class="ribbon">
        <span translate="global.ribbon.{{ ribbonEnv }}">{{ ribbonEnv }}</span>
        <span class="version">{{ version }}</span>
      </div>
    }
  `,
  styleUrls: ['page-ribbon.scss'],
  imports: [TranslateDirective],
})
export class PageRibbonComponent implements OnInit {
  private readonly environmentService = inject(ENVIRONMENT_SERVICE_TOKEN) as EnvironmentService;

  ribbonEnv: string;
  version: string;

  ngOnInit(): void {
    this.ribbonEnv = this.environmentService.getEnvironment().env;
    this.version = packageInfo.version;
  }
}
